"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateDriverFaqsDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const create_driver_faq_dto_1 = require("./create-driver-faq.dto");
const update_driver_faq_dto_1 = require("./update-driver-faq.dto");
class UpdateDriverFaqsDto {
}
exports.UpdateDriverFaqsDto = UpdateDriverFaqsDto;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => create_driver_faq_dto_1.CreateDriverFaqDto),
    __metadata("design:type", Array)
], UpdateDriverFaqsDto.prototype, "create", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Type)(() => update_driver_faq_dto_1.UpdateDriverFaqDto),
    __metadata("design:type", Array)
], UpdateDriverFaqsDto.prototype, "update", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsUUID)("4", { each: true }),
    __metadata("design:type", Array)
], UpdateDriverFaqsDto.prototype, "remove", void 0);
//# sourceMappingURL=update-driver-faqs.dto.js.map